import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { syncUrlParams, search } from '../../state/actions';
import { StateType } from '../../../state/state.types';

const mapState = ({ queryParams }: StateType) => ({
  originalQueryKey: queryParams.originalQueryKey,
});

const mapDispatch = (dispatch: ThunkDispatch<StateType, {}, AnyAction>) => ({
  replaySearch(url: string) {
    dispatch(syncUrlParams(url));
    dispatch(search({ reason: 'browser_navigation' }));
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
